import React from 'react';
import PropTypes from 'prop-types';
import { jsStyles } from './TopBar.styles';
/**
 * Контейнер для сдвига к началу
 *
 * @visibleName TopBar.Start
 */

export var TopBarStart = function TopBarStart(_a) {
  var children = _a.children;
  return React.createElement("div", {
    className: jsStyles.startItems()
  }, children);
};
TopBarStart.__KONTUR_REACT_UI__ = 'TopBarStart';
TopBarStart.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};